import 'magnific-popup';

const $win = $(window);
const $doc = $(document);

$doc
  .on('click', '.js-accordion-size-chart-trigger', function (e) {
    e.preventDefault();

    const $this = $(this);
    const $target = $('.js-accordion-size-chart');

    $target.find('.js-accordion-toggle').trigger('click');

    if ($target.length) {
      $('html, body').animate(
        {
          scrollTop:
            $target.offset().top -
            $('.header').outerHeight() -
            $('.js-bar').outerHeight() -
            80,
        },
        1000
      );
    }
  })
  .on('click', '.js-accordion-reviews-trigger', function (e) {
    e.preventDefault();

    const $this = $(this);
    const $target = $('.js-accordion-reviews');

    $target.find('.js-accordion-toggle').trigger('click');

    if ($target.length) {
      $('html, body').animate(
        {
          scrollTop:
            $target.offset().top -
            $('.header').outerHeight() -
            $('.js-bar').outerHeight() -
            80,
        },
        1000
      );
    }
  });

/**
 * PDP Zoom
 */
$('.js-image-lightbox').magnificPopup({
  type: 'image',
  closeOnContentClick: true,
  closeBtnInside: false,
  fixedContentPos: true,
  mainClass: 'mfp-no-margins mfp-with-zoom',
  image: {
    verticalFit: true,
  },
});
